import { doc, updateDoc } from 'firebase/firestore';

import { firestore } from '../firebase';

export function useGhinStagingMutators() {
  const triggerUpdateNow = async (year: string) => {
    const ref = doc(firestore, 'ghin_staging', year);
    await updateDoc(ref, { updateNow: true });
  };

  return { triggerUpdateNow };
}
